import { render, staticRenderFns } from "./PageEditorContentMoveUpBtn.vue?vue&type=template&id=2dec01fb&scoped=true"
import script from "./PageEditorContentMoveUpBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorContentMoveUpBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec01fb",
  null
  
)

export default component.exports